import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=6d68e784&scoped=true&"
import script from "./VerticalTabs.vue?vue&type=script&lang=js&"
export * from "./VerticalTabs.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTabs.vue?vue&type=style&index=0&id=6d68e784&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68e784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d68e784')) {
      api.createRecord('6d68e784', component.options)
    } else {
      api.reload('6d68e784', component.options)
    }
    module.hot.accept("./VerticalTabs.vue?vue&type=template&id=6d68e784&scoped=true&", function () {
      api.rerender('6d68e784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LinkInstructions/VerticalTabs.vue"
export default component.exports